<template>
  <page>
    <template v-slot:header>
      <CCol xs="12" sm="4" class="offset-sm-4">
        <div class="text-center">
          <h1 class="mb-3 font-5xl">
            {{ $t('faqs.index.header.help.title') }}
          </h1>
          <p @click="goToContact" class="m-0 goToContact" v-html="$t('faqs.index.header.help.subTitle')"></p>
        </div>
      </CCol>
    </template>
    <CCol class="pt-5">
      <CRow>
        <CCol xs="6" sm="4" v-for="item in listItems" :key="item.label" class="mt-4">
          <router-link class="p-4 content-center bg-white shadow-sm rounded-sm" :to="{ name: 'questions', params: { contentName: item.link } }">
            <h5 class="font-2xl p-3 text-black-50">
              {{ item.label }}
            </h5>
          </router-link>
        </CCol>
      </CRow>
    </CCol>
  </page>
</template>

<script>
import page from './Page.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'indexHelp',
  components: {
    page,
  },

  data() {
    return {
      listItems: [],
    }
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
  },

  mounted() {
    this.updateItems()
  },

  methods: {
    updateItems() {
      this.listItems = [
        { link: 'faq-general', label: this.$t('faqs.index.menu.item.general') },
        { link: 'faq-getting-start', label: this.$t('faqs.index.menu.item.getting-started') },
        { link: 'faq-plan-billing', label: this.$t('faqs.index.menu.item.plan-billing') },
        { link: 'faq-audience-management', label: this.$t('faqs.index.menu.item.audience-managment') },
        { link: 'faq-campaign-managment', label: this.$t('faqs.index.menu.item.campaign-managment') },
        { link: 'faq-api', label: this.$t('faqs.index.menu.item.api-documentation') },
      ]
    },
    goToContact() {
      this.$router.push({ name: 'contactFaq' })
    },
  },

  watch: {
    lang: {
      handler() {
        this.updateItems()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.goToContact {
  cursor: pointer;
}
</style>
